import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import HeaderContainer from "../../components/ContainerComponents/HeaderContainer";
import MainContainer from "../../components/ContainerComponents/MainContainer";
import AdminTable from "./AdminTable";

const Admins = () => {
    const { t } = useTranslation();

    return (
        <MainContainer>
            <HeaderContainer title={t('index.ADMIN_CONTACTS')}/>
            <Row>
                <AdminTable/>
            </Row>
        </MainContainer>
    );
};

export default Admins;